import { useState } from "react";
import { guides } from "@/mocks/homeData";
import SectionHeading from "@/components/base/SectionHeading";

export default function Guide() {
  const [openId, setOpenId] = useState<string>(guides[0]?.id ?? "");

  const toggle = (id: string) => setOpenId((prev) => (prev === id ? "" : id));

  return (
    <section id="guide" className="scroll-mt-24 bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="Collecting Guide"
          title="写真收藏指南"
          desc="同样一组写真，看的角度不同，收获也完全不同。这四条经验可以帮助你更系统地欣赏与整理收藏。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2">
          {guides.map((guide) => {
            const isOpen = openId === guide.id;
            return (
              <article
                key={guide.id}
                className={`flex flex-col rounded-lg border bg-background-50 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200 hover:border-primary-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(guide.id)}
                  aria-expanded={isOpen}
                  className="flex w-full items-start gap-4 p-5 text-left"
                >
                  <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${guide.icon} text-xl`} />
                  </span>
                  <span className="flex-1">
                    <span className="block font-heading text-base font-semibold text-foreground-950 md:text-lg">
                      {guide.title}
                    </span>
                    <span className="mt-1 block text-sm leading-relaxed text-foreground-600">
                      {guide.summary}
                    </span>
                  </span>
                  <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center text-foreground-400">
                    <i className={isOpen ? "ri-subtract-line text-lg" : "ri-add-line text-lg"} />
                  </span>
                </button>
                {isOpen ? (
                  <div className="animate-fadeIn px-5 pb-5 pl-[4.75rem]">
                    <p className="text-sm leading-relaxed text-foreground-600">{guide.detail}</p>
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}